<template>
  <div class="public-header display-flex-between">
    <div>
      <img v-if="isHome" class="logo vertical-middle" src="~@assets/img/logo-header.png">
      <img v-else class="logo vertical-middle" src="~@assets/img/logo-header-black.png">
      <nav class="vertical-middle">
        <div v-for="item in navData" class="item inline-block" :class="{ active: (item.path && ($route.meta.menuPath == item.path || $route.path == item.path)) || (item.children && item.children.some(i => i.path == $route.path)) || (item.children && item.children.some(i => i.path == $route.meta.menuPath)) }">
          <div>
            <router-link :to="item.path" @click="hideChild" class="link">{{ item.name }}</router-link>
            <div class="child-wrap" v-if="item.children">
              <ul>
                <li v-for="item2 in item.children" :class="{ active: $route.path === item2.path || $route.meta.menuPath == item2.path }" @click="hideChild">
                  <router-link :to="item2.path">{{ item2.name }}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <div class="right-part flex flex-align-center">
      <!-- <a href="http://b.tanwuapp.com/dist/#/login" target="_blank" class="font-bold select-point">合作方登录</a> -->
      <span class="btn normal-btn" data-text="体验探物租赁" @click="toggleExperience(true)"></span>
    </div>
    <div class="popup-wrap flex-center" v-show="experienceFlag">
      <span class="bg" @click="toggleExperience(false)"></span>
      <div class="experience-box">
        <img class="phone" src="https://resource.tanwuapp.com/FsFApNQKR2eyJu0tjv_v8wLvVvAc" alt="">
        <p class="title flex flex-align-center">
          <img src="~@assets/img/logo.png" alt="">
          <span>扫码体验探物租赁</span>
        </p>
        <p class="text">极速免押金租赁体验，新人更享299元优惠！</p>
        <p class="text">每一天都有新的惊喜，新奇且高品质的科技数码。</p>
        <ul class="code-list">
          <li class="vertical-middle" :class="{ active: codeIndex == 0 }">
            <span class="btn" @click="codeIndex = 0">支付宝小程序</span>
            <div class="code-wrap">
              <img src="~@assets/img/code/code-alipay.png">
              <p>支付宝扫码免押租</p>
            </div>
          </li>
          <li class="vertical-middle" :class="{ active: codeIndex == 1 }">
            <span class="btn" @click="codeIndex = 1">探物APP</span>
            <div class="code-wrap">
              <img src="~@assets/img/code/code-app.png">
              <p>下载探物APP</p>
            </div>
          </li>
          <li class="vertical-middle" :class="{ active: codeIndex == 2 }">
            <span class="btn" @click="codeIndex = 2">微信小程序</span>
            <div class="code-wrap">
              <img src="~@assets/img/code/code-wechat.jpg">
              <p>探物微信小程序</p>
            </div>
          </li>
        </ul>
        <img class="popup-close" src="~@assets/img/popup-close.png" @click="toggleExperience(false)">
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  data() {
    return {
      navData: [
        {
          name: '首页',
          path: '/home'
        },
        {
          name: '关于探物',
          path: '/aboutUs',
          // children:[
          // 	{
          // 		name:'关于探物',
          // 		path:'/aboutUs'
          // 	},
          // 	{
          // 		name:'探物资讯',
          // 		path:'/news'
          // 	},
          // 	{
          // 		name:'加入我们',
          // 		path:'/joinUs'
          // 	},
          // ]
        },
        {
          name: '租赁中心',
          path: '/rent'
        },
        {
          name: '产品测评',
          path: '/assess'
        },
        {
          name: '商务合作',
          path: '/partner'
        },
        {
          name: '加入我们',
          path: '/joinUs'
        },
      ],
      codeIndex: 0,
      experienceFlag: false
    }
  },
  props: ['isHome'],
  methods: {
    hideChild() {
      document.querySelector('.child-wrap').classList.add('none');
      setTimeout(function () {
        document.querySelector('.child-wrap').classList.remove('none');
      }, 100)
    },
    toggleExperience(type) {
      let body = document.querySelector('body');
      body.style.overflow = type ? 'hidden' : 'auto';
      this.experienceFlag = type;
    }
  }
}
</script>

<style lang="scss">
.public-header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  min-width: 900px;
  box-sizing: border-box;
  padding: 13px 50px;
  border-bottom: 1px solid rgba($color: #eee, $alpha: 0.5);
  background: #ffffff;
  z-index: 100;

  @media only screen and (max-width: 1200px) {
    padding-left: 30px;
    padding-right: 30px;
  }

  .logo {
    width: 120px;
    margin-top: -3px;
    transition: width 0.2s;

    @media only screen and (max-width: 1200px) {
      width: 100px;
    }
  }

  nav {
    margin-left: 88px;
    transition: margin-left .3s;

    .item {
      font-weight: bold;
      position: relative;
      margin-right: 44px;
      line-height: 48px;
      cursor: pointer;
      transition: margin-right 0.2s;

      &::after {
        content: '';
        position: absolute;
        background: #3ED8C4;
        height: 4px;
        border-radius: 2px;
        left: 50%;
        bottom: 3px;
        margin-left: -11px;
        width: 22px;
        transition: transform .3s;
        transform: scaleX(0);
        transform-origin: 100% 0;
      }

      &.active {
        color: #3ED8C4;
      }

      &:hover::after,
      &.active::after {
        transform: scaleX(1);
        transform-origin: 0 0;
      }

      .link {
        position: relative;
        display: block;
        z-index: 10;
      }

      .child-wrap {
        display: none;
        position: absolute;
        width: 124px;
        left: 50%;
        margin-left: -62px;
        top: 36px;
        padding-top: 30px;
        color: #000000;
        font-weight: normal;

        ul {
          background: #FFFFFF;
          border-radius: 4px;
          overflow: hidden;
          line-height: 38px;
          text-align: center;
          font-size: 14px;
          padding: 9px 0;
          box-shadow: 0 0 4px rgba($color: #000000, $alpha: 0.1);

          li {
            transition: all 0.3s;

            &:hover,
            &.active {
              color: #3ED8C4;
            }

            &.active {
              font-weight: bold;
            }
          }
        }
      }

      &:hover {
        .child-wrap:not(.none) {
          display: block;
          animation: toRightAnim 0.5s;
        }
      }

      @media only screen and (max-width: 1200px) {
        margin-right: 20px;
      }
    }

    @media only screen and (max-width: 1200px) {
      margin-left: 40px;
      font-size: 14px;
    }
  }

  .right-part {
    .btn {
      width: 126px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      box-shadow: none;
      margin-left: 40px;
    }

    @media only screen and (max-width: 1200px) {
      font-size: 14px;
    }
  }

  .experience-box {
    position: relative;
    box-sizing: border-box;
    background: #ffffff url('https://resource.tanwuapp.com/FhpbCgzbANC5hrCq1K5XcypCnLUg') no-repeat center;
    background-size: cover;
    color: #000000;
    width: 960px;
    height: 580px;
    padding-top: 96px;
    padding-left: 472px;
    border-radius: 18px;
    opacity: 0;
    transform: translateX(-20%);
    animation: downAnim 0.2s ease-out 0.2s;
    animation-fill-mode: forwards;

    .phone {
      position: absolute;
      left: 125px;
      bottom: 30px;
      width: 298px;
    }

    .title {
      font-size: 34px;
      font-weight: bold;
      margin-bottom: 14px;

      img {
        width: 50px;
        margin-right: 12px;
      }
    }

    .text {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 6px;
    }

    .code-list {
      padding-top: 20px;

      li {
        position: relative;
        font-size: 14px;
        margin-right: 7px;

        .btn {
          display: block;
          box-sizing: border-box;
          text-align: center;
          width: 110px;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          background: #ffffff;
          border: 1px solid #000000;
          cursor: pointer;
          user-select: none;
          transition: all 0.2s;
        }

        .code-wrap {
          display: none;
          position: absolute;
          top: 60px;
          text-align: center;
          padding-bottom: 6px;
          border: 2px solid #000000;
          border-radius: 10px;
          color: #333333;
          overflow: hidden;
          transition: all 0.3s;
          background: #ffffff;

          img {
            display: block;
            width: 128px;
          }
        }

        &.active {
          .btn {
            font-weight: bold;
            background: #3ED8C4;
            border-color: #3ED8C4;
            color: #ffffff;
          }

          .code-wrap {
            display: block;
            animation: UpwardAnim 0.3s;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue